export async function postMessageStream({ url, body, headers, onEvent, onDone, onError, signal }) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream', ...headers },
            body: JSON.stringify(body),
            signal,
        });

        if (!response.ok) {
            const text = await response.text().catch(() => '');
            onError && onError(new Error('HTTP ' + response.status + ': ' + text));
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { value, done } = await reader.read();

            if (done) break;

            buffer += decoder.decode(value, { stream: true });

            let boundary = buffer.indexOf('\n\n');
            while (boundary !== -1) {
                const raw = buffer.slice(0, boundary).trim();
                buffer = buffer.slice(boundary + 2);
                boundary = buffer.indexOf('\n\n');

                if (!raw.startsWith('data:')) continue;
                const payload = raw.slice(5).trim();

                if (payload === '[DONE]') {
                    onDone && onDone();
                    return;
                }

                try {
                    const parsed = JSON.parse(payload);
                    onEvent && onEvent(parsed);
                } catch (e) {
                    // skip malformed frames silently
                }
            }
        }

        onDone && onDone();
    } catch (err) {
        if (err && err.name === 'AbortError') return;
        onError && onError(err);
    }
}

export async function postPreset({ url, body, headers }) {
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...headers },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error('preset request failed: ' + response.status);
    }

    return response.json();
}
